import type { Update } from '@ngrx/entity';
import type { NormalizedBlockEntity, DenormalizedBlockEntity, WidgetCorrelationData } from '@web/types';

import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { type Uuid } from '@common/types';

const BlocksActions = createActionGroup({
    source: 'PageStructure/Blocks',
    events: {
        init: props<{ blocks: NormalizedBlockEntity[] }>(),
        'Add block': props<{ block: DenormalizedBlockEntity; index: number }>(),
        'Block added': props<{ block: NormalizedBlockEntity; index: number }>(),
        'Create block': props<{ index: number; widgetCorrelationData?: WidgetCorrelationData }>(),
        'Create specific block': props<{ index: number }>(),
        'Create zero block': props<{ index: number }>(),
        'Block created': props<{ block: NormalizedBlockEntity; index: number }>(),
        'Copy block': props<{ initialBlock: DenormalizedBlockEntity; index: number }>(),
        'Block copied': props<{
            initialBlock: DenormalizedBlockEntity;
            copiedBlock: NormalizedBlockEntity;
            copiedBlockEntity: DenormalizedBlockEntity;
            index: number;
        }>(),
        'Remove block': props<{ block: DenormalizedBlockEntity; index: number; skipHistory?: boolean }>(),
        'Move up': props<{ index: number; skipHistory?: boolean }>(),
        'Move down': props<{ index: number; skipHistory?: boolean }>(),
        'Update block properties': props<{ update: Update<NormalizedBlockEntity> }>(),
        'Copy block to page': props<{ initialBlock: DenormalizedBlockEntity }>(),
        'Copy block to page request': props<{ pageIds: number[]; block: DenormalizedBlockEntity }>(),
        'Copy block to page success': emptyProps(),
        'Copy block to page failure': props<{ error: string }>(),
        'Hide block': props<{ blockId: Uuid; pageId: Uuid | number }>(),
        'Show block': props<{ blockId: Uuid; pageId: Uuid | number }>(),
    },
});

export default BlocksActions;
